import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import { Dropdown } from "react-bootstrap";

import plus_icon from "../../assets/images/plus_icon_blue.svg";
import close_icon from "../../assets/images/close_icon.svg";

import { maskAccountDetail } from "../../utils/maskUtils";

import {
  fetchStates,
  fetchCities,
} from "../../store/slices/locationSlice";

const StepItem = ({
  stepId,
  title,
  subtitle,
  showImage = false,
  imageSrc,
  fields = [],
  showCheckbox = false,
  checkboxes = [],
  headings = [],
  formData = {},
  errors = {},
  onFieldChange,
  onCheckboxChange,
  onImageClick,
  maskFields = [],
  onOpenLocationPopup,
}) => {
  const dispatch = useDispatch();

  const [checkedItems, setCheckedItems] =
    useState({});

  const [focusedField, setFocusedField] =
    useState(null);

  // CHECKBOX
  const handleCheckboxChange = (
    id,
    value
  ) => {
    setCheckedItems((prev) => ({
      ...prev,
      [id]: value,
    }));

    onCheckboxChange(
      stepId,
      id,
      value
    );
  };

  // DISPLAY HELPERS
  const getDropdownLabel = (field) => {
    const idKeyMap = {
      Country: "CountryId",
      State: "StateId",
      City: "CityId",
    };

    const dataKey =
      idKeyMap[field.label] ||
      field.label;

    const currentVal = String(
      formData[dataKey] || ""
    );

    if (!currentVal) {
      return field.placeholder;
    }

    const matched =
      field.options?.find(
        (o) =>
          String(o.value) === currentVal
      );

    return (
      matched?.label ||
      field.placeholder
    );
  };

  const getDisplayValue = (
    fieldLabel
  ) => {
    if (
      maskFields?.includes(fieldLabel)
    ) {
      if (
        focusedField === fieldLabel
      ) {
        return (
          formData[fieldLabel] || ""
        );
      }

      if (formData[fieldLabel]) {
        return maskAccountDetail(
          formData[fieldLabel]
        );
      }
    }

    return (
      formData[fieldLabel] || ""
    );
  };

  // PHONE
  const handlePhoneInput = (
    e,
    sid,
    label
  ) => {
    onFieldChange(
      sid,
      label,
      e.target.value
        .replace(/\D/g, "")
        .slice(0, 10)
    );
  };

  const isPhoneField = (label) =>
    label === "Phone Number";

  return (
    <div
      className="steps_area"
      id={stepId}
    >
      {title && <h4>{title}</h4>}

      {headings.map((heading, i) => (
        <h3
          key={i}
          className="dynamic_heading"
        >
          {heading}
        </h3>
      ))}

      {showImage && (
        <div
          className={`image_upload no_img mt_30 ${errors.image
            ? "input-error"
            : ""
            }`}
        >
          <img
            src={imageSrc}
            alt="upload"
            onClick={onImageClick}
          />
        </div>
      )}

      <div className="common_input_forms">
        {fields.map(
          (field, index) => {
            const isDisabled =
              (field.label ===
                "State" &&
                !formData?.CountryId) ||
              (field.label ===
                "City" &&
                !formData?.StateId);

            return (
              <div
                key={index}
                className={`form_group ${errors[field.label]
                  ? "input-error"
                  : ""
                  }`}
              >
                <label>
                  {field.label}

                  {field.required && (
                    <span
                      style={{
                        color: "red",
                      }}
                    >
                      {" "}
                      *
                    </span>
                  )}
                </label>

                {/* SELECT */}

                {field.type ===
                  "select" ? (
                  <Form.Select
                    className="form-control"
                    value={String(
                      formData[
                      field.label
                      ] || ""
                    )}
                    onChange={(e) => {
                      onFieldChange(
                        stepId,
                        field.label,
                        e.target.value
                      );

                      if (
                        field.onChange
                      ) {
                        field.onChange(
                          e
                        );
                      }
                    }}
                  >
                    <option value="">
                      {
                        field.placeholder
                      }
                    </option>

                    {field.options?.map(
                      (opt) => (
                        <option
                          key={
                            opt.value
                          }
                          value={String(
                            opt.value
                          )}
                        >
                          {opt.label}
                        </option>
                      )
                    )}
                  </Form.Select>
                ) : field.type ===
                  "dropdown" ? (
                  <Dropdown
                    key={`${stepId}-${field.label}`}
                    autoClose={true}
                    className={
                      isDisabled
                        ? "dropdown-disabled"
                        : ""
                    }
                  >
                    <Dropdown.Toggle
                      className={`select_formula ${getDropdownLabel(
                        field
                      ) !==
                        field.placeholder
                        ? "has-value"
                        : ""
                        }`}
                      variant="primary"
                      disabled={
                        isDisabled
                      }
                    >
                      {getDropdownLabel(
                        field
                      )}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {field.options?.map(
                        (option) => {
                          const isAddNew =
                            option.value ===
                            "__add_new__";

                          const canDelete =
                            !isAddNew &&
                            typeof field.onOptionDelete ===
                            "function";

                          const idKeyMap =
                          {
                            Country:
                              "CountryId",
                            State:
                              "StateId",
                            City:
                              "CityId",
                          };

                          const dataKey =
                            idKeyMap[
                            field.label
                            ] ||
                            field.label;

                          const isSelected =
                            String(
                              formData[
                              dataKey
                              ] || ""
                            ) ===
                            String(
                              option.value
                            );

                          return (
                            <Dropdown.Item
                              key={
                                option.value
                              }
                              active={
                                isSelected
                              }
                              className={
                                isAddNew
                                  ? "steps-dropdown-item-addnew p-0"
                                  : ""
                              }
                              onClick={() => {
                                const value =
                                  String(
                                    option.value
                                  );

                                // ADD NEW
                                if (
                                  isAddNew
                                ) {
                                  setTimeout(
                                    () => {
                                      if (
                                        field.label ===
                                        "Country"
                                      ) {
                                        onOpenLocationPopup?.(
                                          "country"
                                        );
                                      }

                                      if (
                                        field.label ===
                                        "State"
                                      ) {
                                        onOpenLocationPopup?.(
                                          "state",
                                          {
                                            countryId:
                                              formData?.CountryId ||
                                              "",
                                          }
                                        );
                                      }

                                      if (
                                        field.label ===
                                        "City"
                                      ) {
                                        onOpenLocationPopup?.(
                                          "city",
                                          {
                                            stateId:
                                              formData?.StateId ||
                                              "",
                                          }
                                        );
                                      }

                                      if (
                                        ![
                                          "Country",
                                          "State",
                                          "City",
                                        ].includes(
                                          field.label
                                        )
                                      ) {
                                        if (
                                          field.onChange
                                        ) {
                                          field.onChange(
                                            {
                                              target:
                                              {
                                                value:
                                                  option.value,
                                              },
                                            }
                                          );
                                        }
                                      }
                                    },
                                    100
                                  );

                                  return;
                                }

                                // COUNTRY
                                if (
                                  field.label ===
                                  "Country"
                                ) {
                                  onFieldChange(
                                    stepId,
                                    "CountryId",
                                    value
                                  );

                                  onFieldChange(
                                    stepId,
                                    "Country",
                                    value
                                  );

                                  onFieldChange(
                                    stepId,
                                    "StateId",
                                    ""
                                  );

                                  onFieldChange(
                                    stepId,
                                    "State",
                                    ""
                                  );

                                  onFieldChange(
                                    stepId,
                                    "CityId",
                                    ""
                                  );

                                  onFieldChange(
                                    stepId,
                                    "City",
                                    ""
                                  );

                                  dispatch(
                                    fetchStates(
                                      value
                                    )
                                  );

                                  return;
                                }

                                // STATE
                                if (
                                  field.label ===
                                  "State"
                                ) {
                                  onFieldChange(
                                    stepId,
                                    "StateId",
                                    value
                                  );

                                  onFieldChange(
                                    stepId,
                                    "State",
                                    value
                                  );

                                  onFieldChange(
                                    stepId,
                                    "CityId",
                                    ""
                                  );

                                  onFieldChange(
                                    stepId,
                                    "City",
                                    ""
                                  );

                                  dispatch(
                                    fetchCities(
                                      value
                                    )
                                  );

                                  return;
                                }

                                // CITY
                                if (
                                  field.label ===
                                  "City"
                                ) {
                                  onFieldChange(
                                    stepId,
                                    "CityId",
                                    value
                                  );

                                  onFieldChange(
                                    stepId,
                                    "City",
                                    value
                                  );

                                  return;
                                }

                                // OTHER DROPDOWN
                                onFieldChange(
                                  stepId,
                                  field.label,
                                  value
                                );

                                if (
                                  field.onChange
                                ) {
                                  field.onChange(
                                    {
                                      target:
                                      {
                                        value,
                                      },
                                      option,
                                    }
                                  );
                                }
                              }}
                            >
                              {isAddNew ? (
                                <span className="steps-dropdown-item-addnew-left">
                                  <img
                                    src={
                                      plus_icon
                                    }
                                    alt="add"
                                  />

                                  <span>
                                    {
                                      option.label
                                    }
                                  </span>
                                </span>
                              ) : (
                                <div className="d-flex align-items-center justify-content-between w-100">
                                  <span>
                                    {
                                      option.label
                                    }
                                  </span>

                                  {canDelete && (
                                    <button
                                      type="button"
                                      className="btn btn-link p-0 ms-2"
                                      style={{
                                        lineHeight: 0,
                                        color:
                                          "#dc3545",
                                        display:
                                          "flex",
                                        alignItems:
                                          "center",
                                      }}
                                      aria-label="delete option"
                                      onClick={(
                                        e
                                      ) => {
                                        e.preventDefault();

                                        e.stopPropagation();

                                        field.onOptionDelete(
                                          option
                                        );
                                      }}
                                    >
                                      <img
                                        src={
                                          close_icon
                                        }
                                        alt="remove"
                                        style={{
                                          width: 14,
                                          height: 14,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                              )}
                            </Dropdown.Item>
                          );
                        }
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                ) : field.type ===
                  "file" ? (
                  <input
                    type="file"
                    className="form-control"
                    accept={
                      field.accept
                    }
                    onChange={(e) =>
                      onFieldChange(
                        stepId,
                        field.label,
                        e.target
                          .files[0]
                      )
                    }
                  />
                ) : (
                  <input
                    type={
                      field.type ||
                      "text"
                    }
                    className="form-control"
                    placeholder={
                      field.placeholder
                    }
                    value={getDisplayValue(
                      field.label
                    )}
                    maxLength={
                      isPhoneField(
                        field.label
                      )
                        ? 10
                        : field.maxLength
                    }
                    autoComplete={
                      field.type ===
                        "password"
                        ? "new-password"
                        : field.type ===
                          "email"
                          ? "new-email"
                          : field.label ===
                            "Phone Number"
                            ? "new-tel"
                            : "off"
                    }
                    name={`${field.label}-${stepId}`}
                    data-lpignore="true"
                    data-form-type="other"
                    max={
                      field.type ===
                        "date"
                        ? new Date()
                          .toISOString()
                          .split(
                            "T"
                          )[0]
                        : undefined
                    }
                    onFocus={() =>
                      setFocusedField(
                        field.label
                      )
                    }
                    onBlur={() =>
                      setFocusedField(
                        null
                      )
                    }
                    onChange={(e) =>
                      isPhoneField(
                        field.label
                      )
                        ? handlePhoneInput(
                          e,
                          stepId,
                          field.label
                        )
                        : onFieldChange(
                          stepId,
                          field.label,
                          e.target
                            .value
                        )
                    }
                  />
                )}

                {field.label ===
                  "Phone Number" &&
                  errors[
                  field.label
                  ] && (
                    <div
                      className="error-message"
                      style={{
                        color: "red",
                        fontSize:
                          "12px",
                        marginTop:
                          "4px",
                      }}
                    >
                      {
                        errors[
                        field.label
                        ]
                      }
                    </div>
                  )}
              </div>
            );
          }
        )}

        {showCheckbox &&
          checkboxes.length >
          0 && (
            <div className="checkboxes mt_24">
              {subtitle && (
                <h5>
                  {subtitle}
                </h5>
              )}

              <Form>
                {checkboxes.map(
                  (cb, i) => (
                    <Form.Check
                      key={
                        cb.id ||
                        `${stepId}-checkbox-${i}`
                      }
                      type="checkbox"
                      label={
                        <>
                          {cb.label}{" "}
                          <span>
                            {
                              cb.spanText
                            }
                          </span>
                        </>
                      }
                      checked={
                        checkedItems[
                        cb.id
                        ] || false
                      }
                      onChange={(
                        e
                      ) =>
                        handleCheckboxChange(
                          cb.id,
                          e.target
                            .checked
                        )
                      }
                    />
                  )
                )}
              </Form>
            </div>
          )}
      </div>
    </div>
  );
};

export default StepItem;